import { WidthContainer } from '@pata-app/ui-document';
import { SponsoredPlacement, useSponsoredPlacement } from '@pata-app/ui-sponsored-placements';

import React from 'react';

import { AdContainer } from './businessAd.styled';

export default function BusinessAd() {
  const adPlacement = useSponsoredPlacement('home.section.sponsored_section');


  if (!adPlacement) {
    return null;
  }

  return (
    <WidthContainer noBackground>
      <AdContainer>
        <SponsoredPlacement placementKey="home.section.sponsored_section" />
      </AdContainer>
    </WidthContainer>
  );
}
